(function () {
  const SELECTOR = '[data-popular-products]';

  const initSliders = (root) => {
    if (window.SliderWrapper?.init) {
      window.SliderWrapper.init(root);
    }
  };

  const replaceWithRecommendations = (root, htmlText) => {
    const doc = document.createElement('div');
    doc.innerHTML = htmlText;
    const next = doc.querySelector(SELECTOR);
    if (!next) return;

    root.replaceWith(next);
    initSection(next);
  };

  const fetchRecommendations = (root) => {
    const url = root.dataset.recommendationsUrl;
    if (!url || root.dataset.recommendationsFetched === 'true') return;

    root.dataset.recommendationsFetched = 'true';

    fetch(url)
      .then((response) => {
        if (!response.ok) throw new Error('Recommendations request failed');
        return response.text();
      })
      .then((text) => replaceWithRecommendations(root, text))
      .catch((error) => {
        console.error(error);
        root.dataset.recommendationsFetched = 'false';
        const loading = root.querySelector('.popular-products__loading');
        if (loading) loading.hidden = true;
      });
  };

  const observeRecommendations = (root) => {
    if (!root.dataset.recommendationsUrl) return;

    if (!('IntersectionObserver' in window)) {
      fetchRecommendations(root);
      return;
    }

    const observer = new IntersectionObserver(
      (entries, currentObserver) => {
        if (!entries[0]?.isIntersecting) return;
        currentObserver.unobserve(root);
        fetchRecommendations(root);
      },
      { rootMargin: '0px 0px 200px 0px' },
    );

    observer.observe(root);
  };

  const initSection = (root) => {
    if (!root) return;
    initSliders(root);
    observeRecommendations(root);
  };

  const initAll = (scope = document) => {
    const roots = scope.matches?.(SELECTOR)
      ? [scope]
      : Array.from(scope.querySelectorAll?.(SELECTOR) || []);
    roots.forEach(initSection);
  };

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', () => initAll(), { once: true });
  } else {
    initAll();
  }

  document.addEventListener('shopify:section:load', (event) => {
    initAll(event.target);
  });
})();
